import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { EU_SITE } from '@/constants';
import EcoImg from 'eco-design/base/eco-img';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';
import EcoVideo from 'eco-design/base/eco-video';
import { useEffect } from 'react';
import styles from './index.module.scss';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const SolarEnergy: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.stream_ultra_sys');

    const params = [
        {
            title: t('stream_ultra_sys_energynum'),
            desc: t('stream_ultra_sys_energy'),
        },
        {
            title: t('stream_ultra_sys_billsnum'),
            desc: t('stream_ultra_sys_bills'),
        },
        {
            title: t('stream_ultra_sys_consumptionnum'),
            desc: t('stream_ultra_sys_consumption'),
        },
    ];

    useEffect(() => {
        if (typeof window === 'undefined') return;

        // eu才有stream部分
        const asyncFromTo = EU_SITE.includes(locale)
            ? [
                  [`.product-assembly .solar-tips`, { opacity: 1 }, { opacity: 0 }, 0.5],
                  [`.product-sticky-pc .streamEnergy-title`, { opacity: 1 }, { opacity: 0 }, 0.5],
                  [`.product-assembly .ultra-tips`, { opacity: 1 }, { opacity: 0 }, 0.5],
                  [`.product-assembly .stream-tips`, { opacity: 1 }, { opacity: 0 }, 0.5],
                  [`.product-assembly .solar`, { opacity: 1, scale: 1, y: 0, x: 0 }, { opacity: 0, scale: 0.1, y: 250, x: 200 }, 2],
                  [`.product-assembly .ultra`, { opacity: 1, scale: 1, y: 0, x: 0 }, { opacity: 0, scale: 0.1, y: 100, x: -100 }, 2],
                  [`.product-assembly .stream`, { opacity: 1, scale: 1, y: 0, x: 0 }, { opacity: 0, scale: 0.1, y: 200, x: -300 }, 2],
                  [`.product-overview`, { opacity: 0 }, { opacity: 1 }, 2],
              ]
            : [
                  [`.product-assembly .solar-tips`, { opacity: 1 }, { opacity: 0 }, 0.5],
                  [`.product-sticky-pc .streamEnergy-title`, { opacity: 1 }, { opacity: 0 }, 0.5],
                  [`.product-assembly .ultra-tips`, { opacity: 1 }, { opacity: 0 }, 0.5],
                  [`.product-assembly .solar`, { opacity: 1, scale: 1, y: 0 }, { opacity: 0, scale: 0.1, y: 100 }, 2],
                  [`.product-assembly .ultra`, { opacity: 1, scale: 1, y: 0 }, { opacity: 0, scale: 0.1, y: 100 }, 2],
                  [`.product-overview`, { opacity: 0 }, { opacity: 1 }, 2],
              ];
        const asyncTimeLine = EU_SITE.includes(locale) ? [0, 0, 0, 0, 1.5, 1.5, 1.5, 0.75] : [0, 0, 0, 1.5, 1.5, 0.75];

        const sceneA = AniContainer.create({
            triggerElement: `.${styles.StreamEnergy} .product-sticky-pc`,
            triggerHook: 1,
            offset: '100%',
            duration: '150%',
            asyncFromTo,
            asyncTimeLine,
        });
        return () => AniContainer.removeScene(sceneA);
    }, []);

    return (
        <section className={styles.StreamEnergy}>
            <EcoSpace hPc="160px" hPad={['us', 'ca'].includes(locale) ? '0px' : undefined} hH5={['us', 'ca'].includes(locale) ? '0px' : undefined} />
            {/* <p className="StreamEnergy-title">{t('stream_ultra_sys_title')}</p> */}
            <div className="product-sticky-pc">
                <p className="streamEnergy-title">{t('stream_ultra_sys_title')}</p>
                {/* 第一屏 */}
                <div className="product-assembly">
                    <div className="product solar">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1745579501159/solar.png" />
                        <div className="tips solar-tips">{t('stream_ultra_sys_name1')}</div>
                    </div>
                    <div className="product ultra">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744891871662/stream-us.png" />
                        <div className="tips ultra-tips">{t('stream_ultra_sys_name2')}</div>
                    </div>
                    {EU_SITE.includes(locale) && (
                        <div className="product stream">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1745579700184/stream2.png" />
                            <div className="tips stream-tips">{t('stream_ultra_sys_name3')}</div>
                        </div>
                    )}
                </div>
                {/* 第二屏 */}
                <div className="product-overview">
                    <EcoVideo
                        className="energy-video"
                        pc="https://websiteoss.ecoflow.com/upload/video/1745482337532/ultra.mp4"
                        h5="https://websiteoss.ecoflow.com/upload/video/1745482375821/ultra-m.mp4"
                        loop
                        autoPlay
                    />
                    <div className="title-box">
                        <EcoSectionCommon
                            className="product-section"
                            title={t('stream_ultra_sys_work')}
                            titleColor="#fff"
                            subTitle={t('stream_ultra_sys_workdesc')}
                            subTitleColor="#fff"
                        />
                        <div className="params-box">
                            {params.map((param) => {
                                return (
                                    <div className="col" key={param.title}>
                                        <div className="params-title">{param.title}</div>
                                        <div className="params-desc">{param.desc}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            {/* pad */}
            <div className="product-mobile">
                <p className="streamEnergy-title">{t('stream_ultra_sys_title')}</p>
                <div className="product-assembly">
                    <div className="product solar">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1745579501159/solar.png" />
                        <div className="tips solar-tips">{t('stream_ultra_sys_name1')}</div>
                    </div>
                    <div className="product ultra">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744891871662/stream-us.png" />
                        <div className="tips ultra-tips">{t('stream_ultra_sys_name2')}</div>
                    </div>
                    {EU_SITE.includes(locale) && (
                        <div className="product stream">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1745579700184/stream2.png" />
                            <div className="tips stream-tips">{t('stream_ultra_sys_name3')}</div>
                        </div>
                    )}
                </div>
                <div className="product-work">
                    <EcoSectionCommon title={t('stream_ultra_sys_work')} subTitle={t('stream_ultra_sys_workdesc')} className="product-section" />
                    <ul className="product-parameters-list">
                        {params.map((param) => {
                            return (
                                <li className="col" key={param.title}>
                                    <div className="params-title">{param.title}</div>
                                    <div className="params-desc">{param.desc}</div>
                                </li>
                            );
                        })}
                    </ul>
                    <div className="product-house-img">
                        <EcoVideo
                            className="energy-video"
                            pc="https://websiteoss.ecoflow.com/upload/video/1745482337532/ultra.mp4"
                            h5="https://websiteoss.ecoflow.com/upload/video/1745482375821/ultra-m.mp4"
                            loop
                            autoPlay
                        />
                    </div>
                </div>
            </div>
            <EcoSpace hPc="160px" hPad="80px" />
        </section>
    );
};

export default SolarEnergy;
